import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const AudioComponent = lib.styled.div`
  display: flex;
  flex-direction: row;
  margin: 10px;
  align-items: center;
  justify: space-between;
  background-color: ${colors.lightGray09};
  border-radius: 8px;
  padding: 2px 10px 2px 10px!important;

  .delete-action {
    width: 26px;
    height: 26px;
    cursor: pointer;
  }

  .disabled {
    svg {
      fill: ${colors.lightGray05};
    }
    cursor: not-allowed;
  }

  .react-h5-audio-player {
    display: flex!important;
    flex: 1!important;

    .flex {
      height: 40px!important;
      width: 280px!important;
      padding: 0px!important;
      align-items: center!important;
      background-color: transparent!important;
      box-shadow: none!important;
    }

    .progress-bar-wrapper {
      width: 242px!important;
      height: 35px!important;
      flex: none!important;
      padding: 10px 0px 0px 0px!important;
      overflow: hidden!important;
    }

    .toggle-play-wrapper {
      height: 30px!important;
      flex: 1!important;
      max-width: 30px!important;
      margin-left: 0px!important;
      margin-right: 8px!important;
    }

    .toggle-play-button{
      background-color: ${colors.green02}!important;
      width: 25px!important;
      height: 25px!important;
      left: 0px!important;
      margin-left: 0px!important;
      margin-top: 3px!important;
      cursor: pointer;

      .play-icon {
        top: 0px!important;
        left: 9px!important;
        border-left: 10px solid ${colors.white}!important;
        border-top: 6px solid transparent!important;
        border-bottom: 5px solid transparent!important;
        
      }

      .pause-icon {
        box-shadow: ${colors.green02} 3px 0px 0px 0px inset!important;
        left: 8px!important;
        top: 0px!important;
        width: 6px!important;
        height: 10px!important;
        border-left: 3px solid ${colors.white}!important;
        
      }
    }

    .progress-bar {
      height: 2px!important;
      border-radius: 30px!important;
      background-color: ${colors.black}!important;
      opacity: 0.15!important;
      width: 259px!important;
      position: absolute!important;
    }

    .time {
      display: flex!important;
      flex: 1!important;
      flex-direction: row!important;
      align-items: center!important;
      justify-content: space-between!important;
      color: ${colors.lightGray09}!important;

      .current-time, .total-time {
        color: ${colors.black}!important;
        font-size: 8px!important;
        font-weight: bold;
      }
    }

    .volume-controls {
      display: none!important;
    }

    .indicator {
      background-color: ${colors.green02}!important;
      box-shadow: none!important;
      width: 10px!important;
      height: 10px!important;
      top: 6px!important;
      opacity: 1!important;
    }
  }
`;
